import { type FC } from 'react';

import DashboardOutlined from '@mui/icons-material/DashboardOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { AdminNavLinks } from '@/src/components/molecules/CraftSideNav/AdminNavLinks';

import { NavDivider } from './NavDivider';

export const EducationProviderAdminNavLinks: FC = () => (
  <>
    <SideNavButton icon={DashboardOutlined} page='dashboard'>
      Dashboard
    </SideNavButton>
    <NavDivider />
    <AdminNavLinks />
  </>
);
